import { getSchedulingQueue } from 'RestAPIs/scheduling-queue';

import { BaseQueue } from 'components/admin-portal/queues/BaseQueue';

const SchedulingQueue = () => {
  const columns = ['id', 'tenantId', 'status', 'inserted', 'started', 'ended'];

  return (
    <BaseQueue
      queueName="schedulingQueue"
      columns={columns}
      getBaseQueue={getSchedulingQueue}
    />
  );
};

export default SchedulingQueue;
